export default "__VITE_ASSET__XXk5ZkGl__"